import React, { useState } from 'react'
import { Button, Col, Input, Label, Row } from 'reactstrap'
import { getReferralTagApi } from '../services/waitlist-service'
import { toast } from 'react-toastify'
import { useHistory } from "react-router-dom"
import SocialMediaPopover from './SocialMediaPopover'
import { isMobile } from 'react-device-detect'  

const ReferCode = (props) => {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [popoverOpen, setPopoverOpen] = useState(false);

    const fdFold = [
        {
            amount: "₹300",
            text: "1st friend booking first FD",
            img: "https://placehold.co/41x46"
        },
        {
            amount: "₹400",
            text: "2nd friend booking first FD",
            img: "https://placehold.co/41x46"
        },
        {
            amount: "₹500",
            text: "3rd friend onwards",
            img: "https://placehold.co/41x46"
        }
    ]


    const handleChange = (e) => {
        setEmail(e.target.value);
    }

    const redirectDashboard = () => {
        history.push('/refer-dashboard')
    }

    const isEmailValid = (email) => {
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            toast.error("please enter email id")
        } else if (email && !regex.test(email)) {
            toast.error("invalid email id")
        } else if (email && regex.test(email)) {
            inviteUser(email);
        }
    }

    const inviteUser = () => {
        let payload = {
            "refCode": props.referralsDetail,
            "referral": email,
        };
        getReferralTagApi(payload)
            .then((response) => {
                if (response && response.success) {
                    return toast.success("Invitation sent successfully");
                }
                if (response && !response.successs) {
                    return toast.error(response.message || "somemthing went wrong");
                }
            });
    };

    const togglePopover = () => {
        setPopoverOpen(!popoverOpen);
    };

    return (
        <Row className="mld-invest-refer">
            { props?.activeTab === "Bonds" ? 
                <Col lg={6} sm={12} xs={12} md={12} className='col-first'>
                    <p className='title'>Referral Program</p>
                    <p className='sub-head'>Introducing our exciting referral Program - your opportunity to earn rewards while
                        sharing the love with friends and family!</p>
                    <div className='img-container'>
                        {isMobile ? <img src={process.env.REACT_APP_IMAGES_PATH + "head2.webp"} alt="offer-img" className='w-100' /> : <img src={process.env.REACT_APP_IMAGES_PATH + "head2.webp"} alt="offer-img"/>}
                    </div>
                    <p className='sub-head1'><u><a href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"} target="_blank">T&C Apply.</a></u></p>
                </Col> : null
            }
            { props?.activeTab === "FD" ? 
                <Col lg={6} sm={12} xs={12} md={12} className='col-first'>
                    <p className='title'>Refer and Earn</p>
                    <p className='sub-head'>Introducing our exciting referral Program - your opportunity to earn rewards while
                        sharing the love with friends and family!
                    </p>

                    <p className='fd'>FD referral <span className='text-primary'>Benefits</span></p>
                    
                    <div className='points-fd'>
                        {
                            fdFold.map((item) => (
                                <div className='point'>
                                    <div className='wrap flex-column justified-content-center'>
                                        <p className='amount'>{item.amount}</p>
                                        <p className='desc'>{item.text}</p>
                                    </div>
                                    <img className="fd-img" src={item.img} alt="fdfold"/>
                                </div>
                            )) 
                        }
                    </div>

                    <div className='note-div'>
                        <p className='note'>+ <b>0.25% of amount</b>  (during the offer period) - up to 1 year</p>
                    </div>

                    <img src={process.env.REACT_APP_IMAGES_PATH + "Incred-Hamper.webp"} alt="hamper" className='hamper'/>
                </Col> : null
            }

             <Col lg={5} sm={12} xs={12} md={12} className='col-second'>
             {props.errors && props.errors.length ? <div className='blur'>
                    <p>
                    Complete your KYC to be eligible to Refer<br />
                    <a
                        className="text-secondary text-underline"
                        href='/platform/#/biddeasy-docvault'
                    >
                        Click here to start now
                    </a>
                    </p>
                    </div> : !props.allDocUploaded ? <div className='blur'>
                    <p>
                    Complete your KYC to be eligible to Refer<br />
                    <a
                        className="text-secondary text-underline"
                        href='/platform/#/biddeasy-docvault'
                    >
                        Click here to start now
                    </a>
                    </p>
                    </div> : !props.isUserApproved ? 
                    <div className='blur'>
                    <p>Thank you for sharing your details. We will review your KYC and get back to you.</p>
                    </div> : null}
                <div className={'calc-div ' + (!props.isUserApproved ? "blur-effect" : "")}>
                    <p className='title'>Refer Now</p>
                    <p className='sub-title'>Share your unique referral link with friends & start earning</p>
                    <div className='price-div'>
                        <div className='ref-div'>
                            <Input type='text'
                                placeholder='Enter Email'
                                onChange={handleChange}
                            />
                            <div className='btn-parent'>
                                <Button onClick={() => isEmailValid(email)} ><span className='font-weight-bold'>Send Email Invite</span></Button>
                            </div>
                        </div>
                    </div>
                    <p className='sep-title'>Share referral code</p>

                    {/* <div className='ref-div w-100 d-flex'>
                        <Label>
                            {props.referralsDetail}
                        </Label>
                        <img onClick={() => {navigator.clipboard.writeText(props.referralsDetail); toast.success("Coppied successfully")}} className='copy-path' src={Copy}/>
                        <div className='btn-second'>
                            <Button id="popoverBtn" onClick={togglePopover}>
                                Share Invite
                            </Button>

                        </div>
                    </div> */}
                    <SocialMediaPopover
                        popoverOpen={true}
                        className="btn"
                        referralsDetail={props.referralsDetail}
                        isUserApproved={props.isUserApproved}
                    />
                </div>
                {props.isUserApproved && <p className='mt-2 referal-btn' onClick={redirectDashboard}>View Referral Dashboard</p>}
            </Col>
        </Row>
    )
}

export default ReferCode;